import { use, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InternalLocalizedStringContext } from './InternalLocalizedStringContext'
import type { LocalizedStringLanguageContextState } from './LocalizedStringLanguageContext'

export const useLocalizedStringLanguageContext = () => {
  const context = use(InternalLocalizedStringContext)

  if (!context) {
    return undefined
  }

  const [activeLanguage, setActiveLanguage] = useState<string | undefined>(context.state.activeLanguage)
  const [availableLanguages, setAvailableLanguages] = useState<string[]>(context.state.availableLanguages ?? [])

  useEffect(() => {
    const listener = (state: LocalizedStringLanguageContextState) => {
      setActiveLanguage(state.activeLanguage)
      setAvailableLanguages(state.availableLanguages ?? [])
    }
    context.listeners.add(listener)
    return () => {
      context.listeners.delete(listener)
    }
  }, [context.listeners])

  const {
    i18n: { language },
  } = useTranslation()

  return useMemo(() => {
    return {
      activeLanguage: activeLanguage ?? language ?? 'en',
      availableLanguages,
      setLocalLanguage: context.setLocalLanguage,
    }
  }, [activeLanguage, language, availableLanguages, context.setLocalLanguage])
}
